module.exports = __webpack_public_path__ + "static/cuma_parcmateriel-b54ac893054888785a3e261028421cc3.png";